<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center row>
        <v-dialog
                :item="item"
                :value="value"
                @input="close()"
                v-model="show"
                width="800">
            <v-card>
                <v-list-item three-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Datei ersetzen</v-list-item-title>
                        <v-list-item-subtitle v-if="item">Datei in Ordner ‎<strong>{{ item.name }}</strong> ersetzen
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider/>

                <v-file-input
                        :accept="state.fileType"
                        class="ps-2 pe-3"
                        color="deep-purple accent-4"
                        counter
                        id="add_file_input"
                        label="Upload"
                        multiple
                        outlined
                        placeholder="Hier können sie Dateien hochladen"
                        prepend-icon="mdi-upload"
                        v-model="state.files">

                    <template v-slot:selection="{ index, text }">
                        <v-chip
                                color="deep-purple accent-4"
                                dark
                                label
                                small
                                v-if="index < 2">
                            {{ text }}
                        </v-chip>

                        <span class="overline grey--text text--darken-3 mx-2" v-else-if="index === 2">
                            +{{ state.files.length - 2 }} Datei(en)
                        </span>

                    </template>

                </v-file-input>


                <v-card-actions class="pe-3">
                    <v-spacer/>
                    <v-btn
                            @click="show = false"
                            color="primary">Abbrechen
                    </v-btn>

                    <v-btn
                            @click="replaceItem"
                            color="primary">Hinzufügen
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import FileReplaceDialogStore from "@/ts/stores/FileReplaceDialogStore";

    export default {
        name: "FileReplaceDialog",

        data() {
            return {
                state: FileReplaceDialogStore.state,
                show: false
            }
        },
        props: {
            value: Boolean,
            item: {}
        },
        watch: {
            state: {
                handler() {
                    this.show = this.state.dialogVisible;
                },
                deep: true
            },
            show(val) {
                if (!val) {
                    this.close()
                }
            }
        },
        methods: {
            close() {
                FileReplaceDialogStore.dismiss()
            },
            replaceItem() {
                this.$emit('replaceClick', {'files': this.state.files, 'name': this.state.name});
            }
        }
    }
</script>
